import {HttpGetParams} from '../model/http-get-params.interface';

export function httpGetUrlSerializer(uri: string, service: string, httpGetParams?: HttpGetParams): string {
    let url = `${uri}/${encodeURIComponent(service)}`;

    if (typeof httpGetParams !== 'object') {
        throw new Error('Type mismatch');
    }

    const query = Object.entries(httpGetParams).map(([paramKey, paramValue]) => {
        if (typeof paramValue === 'string' || paramValue instanceof String) {
            return `${encodeURIComponent(paramKey)}=${encodeURIComponent(paramValue.toString())}`;
        }

        if (typeof paramValue === 'number' || paramValue instanceof Number) {
            return `${encodeURIComponent(paramKey)}=${encodeURIComponent(paramValue.toString())}`;
        }

        if (paramValue instanceof Array) {
            return paramValue.map((arrayValue) => {
                return `${encodeURIComponent(paramKey)}[]=${encodeURIComponent(arrayValue)}`
            }).join('&');
        }

        throw new Error('Type mismatch');
    }).join('&');

    if (query.length) {
        return `${url}?${query}`;
    }

    return url;
}